<template>
    <div>
        <Header></Header>
        <div class="row py-3 mb-4 justify-content-between pageTitleDiv">
            <div class="container pl-0">
                <div class="h1 ml-3 mb-0 d-flex align-items-center font-lg pageTitle">
                    {{$ml.get('ALL_NOTIFICATIONS')}}
                </div>
            </div>
        </div>
        <div class="container">
            <!-- <div class="row py-3 px-3 justify-content-between">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('ALL_NOTIFICATIONS')}}
                </div>
            </div> -->
            <div >
                <nav>
                    <div class="nav btn-group notification-nav bg-white border-radius-4 py-1 notificationNavBar gap-1" role="tablist">
                        <a class="btn ml-1 font-weight-bold" :class="{active:notificationTab=='deal'}" id="nav-deal-tab" @click="changeTab('deal')" data-toggle="tab" href="#nav-deal" role="tab" aria-controls="nav-deal" aria-selected="true">{{$ml.get('OPORTUNITY')}}</a>
                        <a class="btn font-weight-bold" :class="{active:notificationTab=='activity'}" id="nav-activity-tab" @click="changeTab('activity')" data-toggle="tab" href="#nav-activity" role="tab" aria-controls="nav-activity" aria-selected="false">{{$ml.get('ACTIVITY')}}</a>
                        <a class="btn mr-1 font-weight-bold" :class="{active:notificationTab=='reminder'}" id="nav-reminder-tab" @click="changeTab('reminder')" data-toggle="tab" href="#nav-reminder" role="tab" aria-controls="nav-reminder" aria-selected="false">{{$ml.get('REMINDER')}}</a>
                    </div>
                </nav>
                <div class="tab-content py-3">
                    <div class="tab-pane fade" :class="{show:notificationTab=='deal',active:notificationTab=='deal'}" id="nav-deal" role="tabpanel" aria-labelledby="nav-deal-tab">
                        <notificationTable :cardType="cardType" :tableColumns="tableColumns" :tableRows="tableRows" @openCard="openCard($event)" />
                    </div>
                    <div class="tab-pane fade" :class="{show:notificationTab=='activity',active:notificationTab=='activity'}" id="nav-activity" role="tabpanel" aria-labelledby="nav-activity-tab">
                        <notificationTable :cardType="cardType" :tableColumns="tableColumns" :tableRows="tableRows" @openCard="openCard($event)" />
                    </div>
                    <div class="tab-pane fade" :class="{show:notificationTab=='reminder',active:notificationTab=='reminder'}" id="nav-reminder" role="tabpanel" aria-labelledby="nav-reminder-tab">
                        <notificationTable :cardType="cardType" :tableColumns="tableColumns" :tableRows="tableRows" @openCard="openCard($event)" />
                    </div>
                </div>
            </div>
            <div class="modal fade" id="addActivity" ref="newActivity" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important;" >
                    <div class="modal-content">
                        <newActivity pageIs="dataType" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" :methods='type' :user="user" :users="users" @refleshData="getActivitiesF()" ></newActivity>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from './header'
import {mapActions,mapGetters} from 'vuex'
import notificationTable from '@/components/notification-table'
import newActivity from '@/components/newActivity'

export default {
    name:"notifications",
    components:{
        Header,
        "notificationTable":notificationTable,
        'newActivity':newActivity
    },
    data() {
        return {
            tableColumns:[],
            tableData:[],
            dealColumns:[
                {prop:'_id',label:"",type:"id"},
                {prop:'title',label:this.$ml.get('OPPORTUNITY_NAME'),type:"name"},
                {prop:'orgId',label:this.$ml.get('COMPANY_NAME'),type:"organization"},
                {prop:'cuid',label:this.$ml.get('HOLDER'),type:"user"},
                {prop:'expectedDate',label:this.$ml.get('ESTIMATED_CLOSING'),type:"date"}
            ],
            activityColumns:[
                {prop:'_id',label:"",type:"id"},
                {prop:'subject',label:this.$ml.get('SUBJECT_ACTIVITY'),type:"name"},
                {prop:'orgId',label:this.$ml.get('COMPANY_NAME'),type:"organizationArray"},
                {prop:'type',label:this.$ml.get('TYPE_ACTIVITY'),type:"activityType"},
                {prop:'assignor',label:this.$ml.get('ASSIGNMENT'),type:"user"},
                {prop:'assignedTo',label:this.$ml.get('ASSIGNED'),type:"user"},
                {prop:'dueDate',label:this.$ml.get('PLANNING_HISTORY'),type:"date"}
            ],
            notificationColumns:[
                {prop:'_id',label:"",type:"id"},
                {prop:'register_subject',label:this.$ml.get('REGISTER_SUBJECT'),type:"name"},
                {prop:'register_type',label:this.$ml.get('REGISTER_TYPE'),type:"registerType"},
                {prop:'organization',label:this.$ml.get('COMPANY_NAME'),type:"organization"},
                {prop:'reminder_date',label:this.$ml.get('REMINDER_DATE'),type:"reminderDate"},
                {prop:'isRead',label:this.$ml.get('READ_INFO'),type:"readInfo"}
            ],
            rawData:[],
            type: "save",
            clearModal:true,
            listenStateStatus:true,
            customFields:[],
            theActivity:{},
            cardType:''
        }
    },
    computed: {
        ...mapGetters(['deals','activities','notifications','user','users','notificationTab']),
        tableRows(){
            const data = this.tableData
            const keys = this.tableColumns
            const result = array => array.map( o => keys.reduce((acc,curr)=>{
                acc[curr.prop] = o[curr.prop]
                return acc
            },{}))
            return result(data)
        }
    },
    methods: {
        ...mapActions(['getDealsForTable','getActivities','getNotifications','updateNotification']),
        changeTab(tab){
            console.log("gelen tab")
            console.log(tab)
            this.tableColumns=[]
            this.tableData=[]
            this.cardType=tab
            if(tab=="deal"){
                //$('#nav-deal').tab('show');
                this.getDealsF()
            }else if(tab=='activity'){
                //$('#nav-activity').tab('show');
                this.getActivitiesF()
            }else if(tab=='reminder'){
                //$('#nav-reminder').tab('show');
                this.getNotificationsF()
            }
        },
        getDealsF(){
            this.tableColumns = this.dealColumns
            var form = {}
            var filterObj = {}
            filterObj.searchMode = 'deals'
            filterObj.name = 'default'
            var andsList = []
            var andsObj ={}
            andsObj.fieldName = "expectedDate"
            andsObj.filterType = "deals"
            andsObj.operator = "equals"
            var valueObj = {}
            var today = new Date()
            var startDate = new Date(today.getTime() - 3*24*60*60000)
            var endDate = new Date(today.getTime() + 3*24*60*60000)
            valueObj.startDate = today
            valueObj.endDate = endDate
            andsObj.value=valueObj
            andsList.push(andsObj)
            filterObj.ands = andsList
            form.pagingSize = 100
            form.pagingOffset = 0
            form.sort = "expectedDate"
            form.sortType= 1
            form.filter = filterObj

            this.getDealsForTable(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log('getDeals then response')
                console.log(res)
                this.tableData = this.deals
                this.rawData = this.deals
            })
        },
        getActivitiesF(){
            this.tableColumns = this.activityColumns
            var form = {}
            var filterObj = {}
            filterObj.searchMode = 'activities'
            filterObj.name = 'default'
            var andsList = []
            var andsObj ={}
            andsObj.fieldName = "dueDate"
            andsObj.filterType = "activities"
            andsObj.operator = "equals"
            var valueObj = {}
            var today = new Date()
            var startDate = new Date(today.getTime() - 3*24*60*60000)
            var endDate = new Date(today.getTime() + 3*24*60*60000)
            valueObj.startDate = today
            valueObj.endDate = endDate
            andsObj.value=valueObj
            andsList.push(andsObj)
            filterObj.ands = andsList
            form.pagingSize = 100
            form.pagingOffset = 0
            form.sort = "dueDate"
            form.sortType= 1
            form.filter = filterObj

            this.getActivities(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log('getActivities then response')
                console.log(res)
                this.tableData = this.activities
                this.rawData = this.activities
                this.customFields = res.content.customFields
            })
        },
        notificationMutator(notifications){
            
            var mutation = []
            if(notifications.length>0){
                
                for(var i in notifications){
                    let reminder = notifications[i].reminder

                    var newNotification = {}
                    newNotification['_id']={}
                    newNotification._id.$oid = notifications[i]._id.$oid

                    newNotification['register_subject']=''
                    newNotification['register_type']=''
                    var organization = {}
                    organization.name =''
                    newNotification['organization'] = organization

                    if(reminder.activity!==undefined&&reminder.activity!==null){
                        newNotification['register_subject']=reminder.activity.subject
                        newNotification['register_type']=this.$ml.get('ACTIVITY')
                        if(reminder.activity.orgId!==undefined){
                            newNotification['organization']=reminder.activity.orgId[0]
                        }
                    }else if(reminder.deal!==undefined&&reminder.deal!==null){
                        newNotification['register_subject']=reminder.deal.title
                        newNotification['register_type']=this.$ml.get('OPPORTUNITY')
                        if(reminder.deal.orgId!==undefined){
                            newNotification['organization']=reminder.deal.orgId
                        }
                    }

                    if(notifications[i].isRead!==null&&notifications[i].isRead!==undefined){
                        newNotification['isRead'] = notifications[i].isRead
                    }else{
                        newNotification['isRead'] = false
                    }

                    newNotification['reminder_date'] = reminder.date.$date
                    
                    mutation.push(newNotification)
                }
            }

            return mutation
        },
        getNotificationsF(){
            this.tableColumns = this.notificationColumns
            var form = {}
            this.getNotifications(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log('getNotifications then response')
                console.log(res)
                var mutatedNotificationData = this.notificationMutator(this.notifications)
                this.rawData = this.notifications
                console.log("mutatedNotificationData")
                console.log(mutatedNotificationData)
                this.tableData = mutatedNotificationData
            })
        },
        formatColumn(data,type){
            if(type=="date"){
                return this.$moment(data.$date).format("DD.MM.YYYY")
            }else if(type=="organization"){
                return data.name
            }else if(type=="user"){
                const user = this.users.filter(e => { 
                    return e._id.$oid==data.$oid
                })[0]
                return user.name+" "+user.surName
            }
            return data
        },
        openCard(form){
            console.log("opencard form")
            console.log(form)
            if(form.cardType=="deal"){
                this.openDealCard(form.id)
            }else if(form.cardType=="activity"){
                this.openActivityModal(form.id)
            }else if(form.cardType=="reminder"){
                this.readReminder(form.id)
            }
        },
        openActivityModal(id){
            console.log("openactivityModal")
            console.log(id)
            var data = this.rawData.filter(a => { return a._id.$oid == id})[0]
            data["edit"]=true
            this.$store.dispatch('editLine', data)
            let statu=true
            this.$store.dispatch('editLineStatu', statu)
            $('#addActivity').modal('show')
        },
        openDealCard(id){
            console.log("openDealCard")
            console.log(id)
            let routeData = this.$router.resolve({path: '/dealCard/'+id});
            window.open(routeData.href, '_blank');
        },
        readReminder(id){
            console.log("readReminder")
            console.log(id)
            var reminder  = this.rawData.filter(r => { return r._id.$oid==id})[0].reminder
            var reminderType = ''
            var form = {}
            form.notificationId = id
            form.isRead = true
            if(reminder.activity!==undefined&&reminder.activity!==null){
                reminderType = 'activity'
                
            }else if(reminder.deal!==undefined&&reminder.deal!==null){
                reminderType = 'deal'
              
            }else{
                return false
            }

            this.updateNotification(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log("upsert reminder on read reminder res")
                console.log(res)
                if(res.status.code=='0'){
                    if(reminderType=='activity'){
                        var data = reminder.activity
                        data["edit"]=true
                        this.$store.dispatch('editLine', data)
                        let statu=true
                        this.$store.dispatch('editLineStatu', statu)
                        $('#addActivity').modal('show')
                    }else if(reminderType=='deal'){
                        this.openDealCard(reminder.dealId.$oid)
                    }
                    this.getNotificationsF()
                }
                
            })
            
        }
    },
    created() {
        this.changeTab(this.notificationTab)
    },
    watch: {
        notificationTab(tab){
            this.changeTab(tab)
        }
    }
}
</script>
<style scoped>
   
    .notification-nav>.btn-primary:not(:disabled):not(.disabled).active, .notification-nav>.btn-primary:not(:disabled):not(.disabled):active{
        background-color: #273142;
        border-color: #273142;
    }.notificationNavBar{
        display: inline-flex;
        gap: 5px;
    }
    .notificationNavBar>.btn{
        width: 139px;
        height: 36px;
        border-radius: 4px !important;
    }
    .pageTitleDiv{
        background-color: #fff;
        /* position: sticky; */
        top: 60px;
        z-index: 99;
    }
    .notificationNavBar .active {
        background-color: #1991eb;
        color: #fff;
        border-radius: 4px !important;
    }
    .notificationNavBar a {
        background-color: transparent;
        color: #1991EB;                    
    }
    .notificationNavBar a:hover{
        background-color: #D1E9FB;
        color: #1991eb;
    }  
    
    
</style>
